import { Chart } from 'chart.js';

import zoomPlugin from 'chartjs-plugin-zoom';

Chart.register(zoomPlugin);

export default defineNuxtPlugin(() => {})